import React from "react";
import PageWrapper from "./PushNotification.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import PushNotificationTable from "../../components/pushNotification/PushNotificationTable";

const Insurance = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.push_notification"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.push_notification"
          }
        ]}
      />
      <div className="user-tbl">
        <PushNotificationTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.permissionReducer,
    authData: {
      token: state.auth.token,
      isLogin: state.auth.isLogin,
      profileImage: state.auth.profile_image,
      adminRoleId: state.auth.admin_role_id,
      adminRole: state.auth.admin_role,
      full_name: state.auth.first_name + " " + state.auth.last_name
    }
  };
};

export default connect(mapStateToProps, null)(Insurance);
